import request from "./request";
import { apis } from "./apis";

// User
export const userLogin = async (data) => {
  const response = await request("post", apis.userLogin, data);
  return response;
};
export const userSignUp = async (data) => {
  const response = await request("post", apis.userSignUp, data);
  return response;
};
export const generateOtp = async (data) => {
  const response = await request("post", apis.genrateOtp, data);
  return response;
};
export const verifyOtp = async (data) => {
  const response = await request("post", apis.verifyOtp, data);
  return response;
};
export const forgotPassword = async (data) => {
  const response = await request("post", apis.forgotPassword, data);
  return response;
};
export const resetPassword = async (user_id, password) => {
  const response = await request("post", apis.resetPassword(user_id), {
    password,
  });
  return response;
};
export const updateProfile = async (passengerId, data) => {
  const response = await request("put", apis.updateProfile(passengerId), data);
  return response;
};
export const updatePassword = async (user_id, data) => {
  const response = await request("post", apis.updatepassword(user_id), data);
  return response;
};
export const deleteAccount = async (user_id) => {
  const response = await request("delete", apis.deleteAccount(user_id));
  return response;
};
export const contactUs = async () => {
  const response = await request("get", apis.contactUs);
  return response;
};
export const faqs = async () => {
  const response = await request("get", apis.faqs);
  return response;
};
export const reservations = async (user_id) => {
  const response = await request("get", apis.reservationsRoute(user_id));
  return response;
};
export const subscriptions = async (user_id) => {
  const response = await request("get", apis.getSubscriptions(user_id));
  return response;
};
export const renewSubscription = async (subscriptionId, deductCutoffFare) => {
  const response = await request(
    "post",
    apis.renewSubscription(subscriptionId) +
      "?deduct_cutoff_fare=" +
      deductCutoffFare,
  );
  return response;
};
export const getReservationTemplates = async (completeRouteId) => {
  const response = await request(
    "get",
    apis.reservationTemplates(completeRouteId),
  );
  return response;
};

// Routes
export const getAllRoutes = async () => {
  const response = await request("get", apis.getAllRoutes);
  return response;
};
export const getStops = async (userId) => {
  const response = await request("get", apis.getStops(userId));
  return response;
};

// Wallet
export const getTransactions = async (userId) => {
  const response = await request("get", apis.getTransactions(userId));
  return response;
};
export const generateTopupInvoice = async (data) => {
  const response = await request("post", apis.generateTopupInvoice, data);
  return response;
};
export const applyCoupon = async (data) => {
  const response = await request("post", apis.applyCoupon, data);
  return response;
};
export const getOnlinePaymentAccounts = async () => {
  const response = await request("get", apis.getOnlinePaymentAccounts);
  return response;
};

// Reserve Seat
export const createReservation = async (data) => {
  const response = await request("post", apis.createReservation, data);
  return response;
};
export const getBalance = async (userId) => {
  const response = await request("get", apis.getBalance(userId));
  return response;
};
export const getFare = async ({ routeId, pickupStopId, dropoffStopId }) => {
  const response = await request(
    "get",
    apis.getFare(routeId, pickupStopId, dropoffStopId),
  );
  return response;
};
export const cancelReservation = async (reservationId) => {
  const response = await request("post", apis.cancelReservation(reservationId));
  return response;
};

// Feedback
export const submitFeedback = async (data) => {
  const response = await request("post", apis.submitFeedback, data);
  return response;
};
export const getAllFeedbacks = async (userId) => {
  const response = await request("get", apis.getAllFeedbacks(userId));
  return response;
};
export const getThread = async (feedbackId) => {
  const response = await request("get", apis.getThread(feedbackId));
  return response;
};
export const getThreadInfo = async (typeId) => {
  const response = await request("get", apis.getThread(typeId));
  return response;
};
export const registerComplaint = async (
  typeid,
  passenger_id,
  parent_id,
  type,
  subject,
  details,
  is_active,
) => {
  const response = await request("post", apis.registerComplaint, {
    typeid,
    passenger_id,
    parent_id,
    type,
    subject,
    details,
    is_active,
  });
  return response;
};
// export const registerComplaint = async (data) => {
//   const response = await request('post', apis.registerComplaint, { data });
//   return response;
// };
export const getMeeznaFormUrl = async (amount) => {
  const response = await request("post", apis.getMeeznaFormUrl, { amount });
  return response;
};
